// If you have a single smart-link (like Branch/Firebase/OneLink), set it here or via env.
export const APP_ONELINK_URL = process.env.REACT_APP_APP_ONELINK_URL || "https://onelink.to/e2s7nt";

// Optional direct store links (override OneLink if provided).
export const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || APP_ONELINK_URL;
export const PLAY_STORE_URL = process.env.REACT_APP_PLAY_STORE_URL || APP_ONELINK_URL;
